import * as React from 'react'

import { NavigationItemType } from '../../NavigationTree'
import { TextNavigationContent } from './TextNavigationContent'
import { Brands } from './Brands'
import { CardNavigationContent } from './CardNavigationContent'
import { ImageCardNavigationContent } from './ImageCardNavigationContent'
import { ImageThumbnailContent } from './ImageThumbnailContent'
import { WaterfallMenuDropdown } from './WaterfallMenuDropdown/WaterfallMenuDropdown'

export const NavigationContent = ({
  item,
  brandsData,
  i18nText,
  routes,
  dynamicWidth,
  hasWaterfallMenu,
}) => {
  switch (item.type) {
    case NavigationItemType.TEXT:
      if (hasWaterfallMenu) {
        return (
          <WaterfallMenuDropdown
            showDetachedList={true}
            navigationItem={item}
          />
        )
      }
      return <TextNavigationContent dynamicWidth={dynamicWidth} item={item} />
    case NavigationItemType.WATERFALL:
      return (
        <WaterfallMenuDropdown showDetachedList={false} navigationItem={item} />
      )

    case NavigationItemType.TEXT_CARD:
      return (
        <CardNavigationContent
          dynamicWidths={dynamicWidth}
          mobile={false}
          i18nHomeText={''}
          item={item}
          isAmp={false}
        />
      )
    case NavigationItemType.IMAGE_CARD:
      return (
        <ImageCardNavigationContent
          dynamicWidths={dynamicWidth}
          mobile={false}
          i18nHomeText={''}
          item={item}
          isAmp={false}
        />
      )
    case NavigationItemType.THUMBNAIL_CARD:
      return (
        <ImageThumbnailContent
          dynamicWidths={dynamicWidth}
          mobile={false}
          i18nHomeText={''}
          item={item}
          isAmp={false}
        />
      )
    case NavigationItemType.BRANDS:
      if (brandsData?.brands) {
        return (
          <Brands
            brandsData={brandsData}
            i18nText={{
              viewAllBrands: i18nText.viewAllBrands,
              navAriaLabel: i18nText.navAriaLabel,
            }}
            viewAllBrandsLink={routes.viewAllBrandsLink}
            listExtension={routes.listExtension}
          />
        )
      }
      return null

    default:
      return <TextNavigationContent dynamicWidth={dynamicWidth} item={item} />
  }
}
